import React from 'react';
// @ts-nocheck
import { Toolbar, Typography, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import MuiAppBar from "@mui/material/AppBar";
import useMediaQuery from "@mui/material/useMediaQuery";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import MenuIcon from "@mui/icons-material/Menu";
import xomeLogo from "../assets/xome-logo-blaze.png";
import { styled, useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useAuth } from "../services/AuthContext"; // Import useAuth hook
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import impersonating from "../assets/Tag.png"
const drawerWidth = 280;
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

function Navbar({
  handleDrawerClose,
  handleDrawerOpen,
  open = false,
  isLogin = false,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { investorId } = useAuth(); // Move useAuth inside Navbar function
  const loginUserDetail = useSelector((store: RootState) => store.user.loginUserDetails)
  const isImpersonate = sessionStorage.getItem("isImpersonate")
  return (
    <AppBar
      sx={{
        backgroundColor: "#fff",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
        width: "100%",
        top: isImpersonate ? 30 : 0,
      }}
      open={isMobile ? undefined : open}
      position="fixed"
    >
      <Toolbar>
        <Grid container sx={{ width: "100%", }} justifyContent={{ md: "space-between", sm: "center" }}>
          <Grid
            size={{ sm: 12, md: 4 }}
            sx={{
              display: "flex",
              justifyContent: isMobile && "center",
              alignItems: "center",
              py: "10px",
              width: "100%"
            }}
          >
            {isMobile ? (
              <img
                src={xomeLogo}
                style={{ width: "22%", height: "auto" }}
                alt="Logo"
              />
            ) : (
              <div className="flex flex-row w-[100%] gap-x-16 p-1.5 justify-center items-center">
                {!open && (
                  <img
                    src={xomeLogo}
                    style={{ width: "20%", height: "auto" }}
                    alt="Logo"
                  />
                )}
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    color: "#3B3B3B",
                    marginTop: 2,
                    textWrap: { sm: "nowrap", xs: "none" }
                  }}
                  variant="body1"
                > {`Welcome, ${isImpersonate === "true" ? loginUserDetail?.ProfileName?.length > 2 ? loginUserDetail?.ProfileName : loginUserDetail?.BusinessAccounts?.[0]?.ProfileName || loginUserDetail?.FirstName && loginUserDetail?.LastName ? loginUserDetail?.FirstName + " " + loginUserDetail?.LastName : "" : investorId?.username}`}
                </Typography>
              </div>
            )}
          </Grid>
          <Grid size={{ xs: 0, sm: 0, md: 4, }} sx={{ display: "flex", alignItems: "center" }}>
            {isLogin && (
              <IconButton
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  ":hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <AccountBalanceWalletOutlinedIcon aria-label="accountBalanceWalletOutlinedIcon-svg" />
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    color: "#3B3B3B",
                    display: { xs: "none", sm: "block" },
                  }}
                >
                  Manage Funds
                </Typography>
              </IconButton>
            )}
            {/* <IconButton
              sx={{
                display: "flex",
                flexDirection: "column",
                ":hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <NotificationsNoneIcon aria-label="notification-svg"/>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "Poppins",
                  color: "#3B3B3B",
                  display: { xs: "none", sm: "block" },
                }}
                variant="caption"
              >
                Notifications
              </Typography>
            </IconButton> */}
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}

Navbar.propTypes = {
  handleDrawerClose: PropTypes.func,
  handleDrawerOpen: PropTypes.func,
  open: PropTypes.bool,
  isLogin: PropTypes.bool,
};

export default Navbar;

